// updates the shoppingcart counter on order pages
// see doc here:
// https://gitlab.rsm-support.de/bawue/frontend/blob/master/src/docs/1-documentation.md#magicMatzeCart
import Cookies from 'js-cookie';
import h from 'hyperscript';
import { updateStickyLinkNumber, toggleStickyLink } from '../../components/atoms/sticky-link/sticky-link';

const $magicMatzeCart = document.querySelector('#magicMatzeCart');

function animations($link) {
  if ($magicMatzeCart) {
    const $serviceLink = $magicMatzeCart.parentNode.parentNode;

    // animations shoppingcart in menu
    if ($serviceLink) {
      $serviceLink.style.display = 'inline';
      $serviceLink.classList.remove('js-add-to-shopping-cart--animation');
      $serviceLink.classList.add('js-add-to-shopping-cart--animation');
    }
  }

  // animations add to shopping cart link
  if ($link) {
    $link.classList.remove('js-add-to-shopping-cart--icon-animation');
    $link.classList.add('js-add-to-shopping-cart--icon-animation');
    $link.querySelector('svg use').setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-cart-filled');
    $link.blur();
  }
}

function updateCartAmount(cartAmount) {
  if ($magicMatzeCart) {
    const $serviceLink = $magicMatzeCart.parentNode.parentNode;

    if (cartAmount > 0) {
      $serviceLink.style.display = 'inline';
      $magicMatzeCart.textContent = cartAmount;
    }
  }

  const $stickyLink = document.querySelector('.sticky-link');

  if ($stickyLink) {
    toggleStickyLink($stickyLink, cartAmount > 0);
    updateStickyLinkNumber($stickyLink, cartAmount);
  }
}

function getCartAmount(url, $link) {
  if (url) {
    const Http = new XMLHttpRequest();
    Http.open('GET', url);
    Http.send();
    Http.onreadystatechange = () => {
      if (Http.readyState === 4 && Http.status === 200) {
        const cartAmount = parseInt(Http.responseText.trim(), 10);
        updateCartAmount(cartAmount);
        if ($link) {
          animations($link, cartAmount);
        }
      }
    };
  }
}

function addToShoppingCart(event, $link) {
  event.preventDefault();
  const { href } = $link;
  if (href) {
    getCartAmount(href, $link);
  }
}

function magicMatzeCartstatus() {
  if ($magicMatzeCart) {
    const $serviceLink = $magicMatzeCart.parentNode.parentNode;
    const getCartUrl = $serviceLink.dataset.getcart;

    if (getCartUrl) {
      getCartAmount(getCartUrl);
    }
  }
}


export const initAddToCartButtons = () => {
  const neededCookie = Cookies.get('bawu-consent') || null;

  if (neededCookie || neededCookie === 'accept') {
    document.querySelectorAll('.js-add-to-shopping-cart').forEach(($link) => {
      $link.removeAttribute('disabled', false);
      $link.addEventListener('click', event => addToShoppingCart(event, $link));
      if ($link.parentNode.querySelector('.icon-link__info')) {
        $link.parentNode.querySelector('.icon-link__info').remove();
      }
    });
  } else {
    document.querySelectorAll('.js-add-to-shopping-cart').forEach(($link) => {
      const $cookieInfo = h('span.icon-link__info', '');
      $cookieInfo.innerHTML = '(benötigt Cookies!)';

      $link.addEventListener('click', event => event.preventDefault());
      $link.setAttribute('disabled', true);
      $link.parentNode.appendChild($cookieInfo);
    });
  }
};

initAddToCartButtons();
magicMatzeCartstatus();
